/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { CategoryMarkupUpsert } from '../models/categoryMarkupUpsert';

import type { CompanySettingsEnvelope } from '../models/companySettingsEnvelope';

import type { CompanySettingsListEnvelope } from '../models/companySettingsListEnvelope';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import type { ModulesProcurementApiSettingsRoutesTenantSettingsUpdate } from '../models/modulesProcurementApiSettingsRoutesTenantSettingsUpdate';

import type { ModulesProcurementApiSettingsRoutesUserSettingsUpdate } from '../models/modulesProcurementApiSettingsRoutesUserSettingsUpdate';

import type { ProcurementCompanySettingsUpdate } from '../models/procurementCompanySettingsUpdate';

import type { UpdateCompanySettingsApiV1ProcurementSettingsCompaniesPutParams } from '../models/updateCompanySettingsApiV1ProcurementSettingsCompaniesPutParams';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * Get tenant's Procurement settings. Requires admin.
 * @summary Get Tenant Settings
 */
export const getTenantSettingsApiV1ProcurementSettingsTenantGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/procurement/settings/tenant`,
    method: 'GET',
    signal
  });
};

export const getGetTenantSettingsApiV1ProcurementSettingsTenantGetQueryKey =
  () => {
    return [`/api/v1/procurement/settings/tenant`] as const;
  };

export const getGetTenantSettingsApiV1ProcurementSettingsTenantGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getTenantSettingsApiV1ProcurementSettingsTenantGet>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTenantSettingsApiV1ProcurementSettingsTenantGet>
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTenantSettingsApiV1ProcurementSettingsTenantGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getTenantSettingsApiV1ProcurementSettingsTenantGet>
      >
    > = ({ signal }) =>
      getTenantSettingsApiV1ProcurementSettingsTenantGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getTenantSettingsApiV1ProcurementSettingsTenantGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetTenantSettingsApiV1ProcurementSettingsTenantGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getTenantSettingsApiV1ProcurementSettingsTenantGet>
    >
  >;
export type GetTenantSettingsApiV1ProcurementSettingsTenantGetQueryError =
  unknown;

export function useGetTenantSettingsApiV1ProcurementSettingsTenantGet<
  TData = Awaited<
    ReturnType<typeof getTenantSettingsApiV1ProcurementSettingsTenantGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTenantSettingsApiV1ProcurementSettingsTenantGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTenantSettingsApiV1ProcurementSettingsTenantGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTenantSettingsApiV1ProcurementSettingsTenantGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTenantSettingsApiV1ProcurementSettingsTenantGet<
  TData = Awaited<
    ReturnType<typeof getTenantSettingsApiV1ProcurementSettingsTenantGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTenantSettingsApiV1ProcurementSettingsTenantGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTenantSettingsApiV1ProcurementSettingsTenantGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTenantSettingsApiV1ProcurementSettingsTenantGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTenantSettingsApiV1ProcurementSettingsTenantGet<
  TData = Awaited<
    ReturnType<typeof getTenantSettingsApiV1ProcurementSettingsTenantGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTenantSettingsApiV1ProcurementSettingsTenantGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Tenant Settings
 */

export function useGetTenantSettingsApiV1ProcurementSettingsTenantGet<
  TData = Awaited<
    ReturnType<typeof getTenantSettingsApiV1ProcurementSettingsTenantGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTenantSettingsApiV1ProcurementSettingsTenantGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetTenantSettingsApiV1ProcurementSettingsTenantGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update tenant's Procurement settings. Requires admin.
 * @summary Update Tenant Settings
 */
export const updateTenantSettingsApiV1ProcurementSettingsTenantPut = (
  modulesProcurementApiSettingsRoutesTenantSettingsUpdate: ModulesProcurementApiSettingsRoutesTenantSettingsUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/procurement/settings/tenant`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: modulesProcurementApiSettingsRoutesTenantSettingsUpdate
  });
};

export const getUpdateTenantSettingsApiV1ProcurementSettingsTenantPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateTenantSettingsApiV1ProcurementSettingsTenantPut>
      >,
      TError,
      { data: ModulesProcurementApiSettingsRoutesTenantSettingsUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateTenantSettingsApiV1ProcurementSettingsTenantPut>
    >,
    TError,
    { data: ModulesProcurementApiSettingsRoutesTenantSettingsUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateTenantSettingsApiV1ProcurementSettingsTenantPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateTenantSettingsApiV1ProcurementSettingsTenantPut>
      >,
      { data: ModulesProcurementApiSettingsRoutesTenantSettingsUpdate }
    > = (props) => {
      const { data } = props ?? {};

      return updateTenantSettingsApiV1ProcurementSettingsTenantPut(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateTenantSettingsApiV1ProcurementSettingsTenantPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateTenantSettingsApiV1ProcurementSettingsTenantPut>
    >
  >;
export type UpdateTenantSettingsApiV1ProcurementSettingsTenantPutMutationBody =
  ModulesProcurementApiSettingsRoutesTenantSettingsUpdate;
export type UpdateTenantSettingsApiV1ProcurementSettingsTenantPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Tenant Settings
 */
export const useUpdateTenantSettingsApiV1ProcurementSettingsTenantPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateTenantSettingsApiV1ProcurementSettingsTenantPut>
      >,
      TError,
      { data: ModulesProcurementApiSettingsRoutesTenantSettingsUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateTenantSettingsApiV1ProcurementSettingsTenantPut>
  >,
  TError,
  { data: ModulesProcurementApiSettingsRoutesTenantSettingsUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateTenantSettingsApiV1ProcurementSettingsTenantPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get current user's Procurement settings.
 * @summary Get User Settings
 */
export const getUserSettingsApiV1ProcurementSettingsUserGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/procurement/settings/user`,
    method: 'GET',
    signal
  });
};

export const getGetUserSettingsApiV1ProcurementSettingsUserGetQueryKey = () => {
  return [`/api/v1/procurement/settings/user`] as const;
};

export const getGetUserSettingsApiV1ProcurementSettingsUserGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getUserSettingsApiV1ProcurementSettingsUserGet>
  >,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof getUserSettingsApiV1ProcurementSettingsUserGet>
      >,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetUserSettingsApiV1ProcurementSettingsUserGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserSettingsApiV1ProcurementSettingsUserGet>>
  > = ({ signal }) => getUserSettingsApiV1ProcurementSettingsUserGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserSettingsApiV1ProcurementSettingsUserGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserSettingsApiV1ProcurementSettingsUserGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getUserSettingsApiV1ProcurementSettingsUserGet>>
  >;
export type GetUserSettingsApiV1ProcurementSettingsUserGetQueryError = unknown;

export function useGetUserSettingsApiV1ProcurementSettingsUserGet<
  TData = Awaited<
    ReturnType<typeof getUserSettingsApiV1ProcurementSettingsUserGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getUserSettingsApiV1ProcurementSettingsUserGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getUserSettingsApiV1ProcurementSettingsUserGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getUserSettingsApiV1ProcurementSettingsUserGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserSettingsApiV1ProcurementSettingsUserGet<
  TData = Awaited<
    ReturnType<typeof getUserSettingsApiV1ProcurementSettingsUserGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getUserSettingsApiV1ProcurementSettingsUserGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getUserSettingsApiV1ProcurementSettingsUserGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getUserSettingsApiV1ProcurementSettingsUserGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserSettingsApiV1ProcurementSettingsUserGet<
  TData = Awaited<
    ReturnType<typeof getUserSettingsApiV1ProcurementSettingsUserGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getUserSettingsApiV1ProcurementSettingsUserGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get User Settings
 */

export function useGetUserSettingsApiV1ProcurementSettingsUserGet<
  TData = Awaited<
    ReturnType<typeof getUserSettingsApiV1ProcurementSettingsUserGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getUserSettingsApiV1ProcurementSettingsUserGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetUserSettingsApiV1ProcurementSettingsUserGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update current user's Procurement settings.
 * @summary Update User Settings
 */
export const updateUserSettingsApiV1ProcurementSettingsUserPut = (
  modulesProcurementApiSettingsRoutesUserSettingsUpdate: ModulesProcurementApiSettingsRoutesUserSettingsUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/procurement/settings/user`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: modulesProcurementApiSettingsRoutesUserSettingsUpdate
  });
};

export const getUpdateUserSettingsApiV1ProcurementSettingsUserPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateUserSettingsApiV1ProcurementSettingsUserPut>
      >,
      TError,
      { data: ModulesProcurementApiSettingsRoutesUserSettingsUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateUserSettingsApiV1ProcurementSettingsUserPut>
    >,
    TError,
    { data: ModulesProcurementApiSettingsRoutesUserSettingsUpdate },
    TContext
  > => {
    const mutationKey = ['updateUserSettingsApiV1ProcurementSettingsUserPut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateUserSettingsApiV1ProcurementSettingsUserPut>
      >,
      { data: ModulesProcurementApiSettingsRoutesUserSettingsUpdate }
    > = (props) => {
      const { data } = props ?? {};

      return updateUserSettingsApiV1ProcurementSettingsUserPut(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateUserSettingsApiV1ProcurementSettingsUserPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateUserSettingsApiV1ProcurementSettingsUserPut>
    >
  >;
export type UpdateUserSettingsApiV1ProcurementSettingsUserPutMutationBody =
  ModulesProcurementApiSettingsRoutesUserSettingsUpdate;
export type UpdateUserSettingsApiV1ProcurementSettingsUserPutMutationError =
  HTTPValidationError;

/**
 * @summary Update User Settings
 */
export const useUpdateUserSettingsApiV1ProcurementSettingsUserPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateUserSettingsApiV1ProcurementSettingsUserPut>
      >,
      TError,
      { data: ModulesProcurementApiSettingsRoutesUserSettingsUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateUserSettingsApiV1ProcurementSettingsUserPut>>,
  TError,
  { data: ModulesProcurementApiSettingsRoutesUserSettingsUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateUserSettingsApiV1ProcurementSettingsUserPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Every stored per-company procurement setting the caller can act on.

Clamped to ``auth.accessible_company_ids``. A company the caller cannot act on
never appears, and a company with no row yet is simply absent — the client
renders the documented default (off) for it.
 * @summary List Company Settings
 */
export const listCompanySettingsApiV1ProcurementSettingsCompaniesGet = (
  signal?: AbortSignal
) => {
  return customInstance<CompanySettingsListEnvelope>({
    url: `/api/v1/procurement/settings/companies`,
    method: 'GET',
    signal
  });
};

export const getListCompanySettingsApiV1ProcurementSettingsCompaniesGetQueryKey =
  () => {
    return [`/api/v1/procurement/settings/companies`] as const;
  };

export const getListCompanySettingsApiV1ProcurementSettingsCompaniesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listCompanySettingsApiV1ProcurementSettingsCompaniesGet>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCompanySettingsApiV1ProcurementSettingsCompaniesGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListCompanySettingsApiV1ProcurementSettingsCompaniesGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listCompanySettingsApiV1ProcurementSettingsCompaniesGet
        >
      >
    > = ({ signal }) =>
      listCompanySettingsApiV1ProcurementSettingsCompaniesGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listCompanySettingsApiV1ProcurementSettingsCompaniesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListCompanySettingsApiV1ProcurementSettingsCompaniesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listCompanySettingsApiV1ProcurementSettingsCompaniesGet>
    >
  >;
export type ListCompanySettingsApiV1ProcurementSettingsCompaniesGetQueryError =
  unknown;

export function useListCompanySettingsApiV1ProcurementSettingsCompaniesGet<
  TData = Awaited<
    ReturnType<typeof listCompanySettingsApiV1ProcurementSettingsCompaniesGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCompanySettingsApiV1ProcurementSettingsCompaniesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCompanySettingsApiV1ProcurementSettingsCompaniesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCompanySettingsApiV1ProcurementSettingsCompaniesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListCompanySettingsApiV1ProcurementSettingsCompaniesGet<
  TData = Awaited<
    ReturnType<typeof listCompanySettingsApiV1ProcurementSettingsCompaniesGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCompanySettingsApiV1ProcurementSettingsCompaniesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCompanySettingsApiV1ProcurementSettingsCompaniesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCompanySettingsApiV1ProcurementSettingsCompaniesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListCompanySettingsApiV1ProcurementSettingsCompaniesGet<
  TData = Awaited<
    ReturnType<typeof listCompanySettingsApiV1ProcurementSettingsCompaniesGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCompanySettingsApiV1ProcurementSettingsCompaniesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Company Settings
 */

export function useListCompanySettingsApiV1ProcurementSettingsCompaniesGet<
  TData = Awaited<
    ReturnType<typeof listCompanySettingsApiV1ProcurementSettingsCompaniesGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCompanySettingsApiV1ProcurementSettingsCompaniesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListCompanySettingsApiV1ProcurementSettingsCompaniesGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Set one company's procurement settings. Requires module admin.

``company_id`` defaults to the caller's active company (app-bar scope), which
is the only possible company on a single-company tenant. It is client-supplied,
so ``resolve_company_id_or_raise`` asserts both tenant membership and the
caller's access before anything is written.
 * @summary Update Company Settings
 */
export const updateCompanySettingsApiV1ProcurementSettingsCompaniesPut = (
  procurementCompanySettingsUpdate: ProcurementCompanySettingsUpdate,
  params?: UpdateCompanySettingsApiV1ProcurementSettingsCompaniesPutParams
) => {
  return customInstance<CompanySettingsEnvelope>({
    url: `/api/v1/procurement/settings/companies`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: procurementCompanySettingsUpdate,
    params
  });
};

export const getUpdateCompanySettingsApiV1ProcurementSettingsCompaniesPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateCompanySettingsApiV1ProcurementSettingsCompaniesPut
        >
      >,
      TError,
      {
        data: ProcurementCompanySettingsUpdate;
        params?: UpdateCompanySettingsApiV1ProcurementSettingsCompaniesPutParams;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateCompanySettingsApiV1ProcurementSettingsCompaniesPut
      >
    >,
    TError,
    {
      data: ProcurementCompanySettingsUpdate;
      params?: UpdateCompanySettingsApiV1ProcurementSettingsCompaniesPutParams;
    },
    TContext
  > => {
    const mutationKey = [
      'updateCompanySettingsApiV1ProcurementSettingsCompaniesPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateCompanySettingsApiV1ProcurementSettingsCompaniesPut
        >
      >,
      {
        data: ProcurementCompanySettingsUpdate;
        params?: UpdateCompanySettingsApiV1ProcurementSettingsCompaniesPutParams;
      }
    > = (props) => {
      const { data, params } = props ?? {};

      return updateCompanySettingsApiV1ProcurementSettingsCompaniesPut(
        data,
        params
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateCompanySettingsApiV1ProcurementSettingsCompaniesPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateCompanySettingsApiV1ProcurementSettingsCompaniesPut
      >
    >
  >;
export type UpdateCompanySettingsApiV1ProcurementSettingsCompaniesPutMutationBody =
  ProcurementCompanySettingsUpdate;
export type UpdateCompanySettingsApiV1ProcurementSettingsCompaniesPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Company Settings
 */
export const useUpdateCompanySettingsApiV1ProcurementSettingsCompaniesPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateCompanySettingsApiV1ProcurementSettingsCompaniesPut
        >
      >,
      TError,
      {
        data: ProcurementCompanySettingsUpdate;
        params?: UpdateCompanySettingsApiV1ProcurementSettingsCompaniesPutParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateCompanySettingsApiV1ProcurementSettingsCompaniesPut>
  >,
  TError,
  {
    data: ProcurementCompanySettingsUpdate;
    params?: UpdateCompanySettingsApiV1ProcurementSettingsCompaniesPutParams;
  },
  TContext
> => {
  const mutationOptions =
    getUpdateCompanySettingsApiV1ProcurementSettingsCompaniesPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List the tenant's per-category markup defaults (custom-goods quote build).
 * @summary List Category Markups
 */
export const listCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/procurement/settings/category-markups`,
    method: 'GET',
    signal
  });
};

export const getListCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGetQueryKey =
  () => {
    return [`/api/v1/procurement/settings/category-markups`] as const;
  };

export const getListCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGet
        >
      >
    > = ({ signal }) =>
      listCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGet
      >
    >
  >;
export type ListCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGetQueryError =
  unknown;

export function useListCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGet<
  TData = Awaited<
    ReturnType<
      typeof listCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGet
    >
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGet<
  TData = Awaited<
    ReturnType<
      typeof listCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGet<
  TData = Awaited<
    ReturnType<
      typeof listCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Category Markups
 */

export function useListCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGet<
  TData = Awaited<
    ReturnType<
      typeof listCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListCategoryMarkupsApiV1ProcurementSettingsCategoryMarkupsGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create or update one category's default markup %. Requires admin.
 * @summary Upsert Category Markup
 */
export const upsertCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsPut = (
  categoryMarkupUpsert: CategoryMarkupUpsert
) => {
  return customInstance<unknown>({
    url: `/api/v1/procurement/settings/category-markups`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: categoryMarkupUpsert
  });
};

export const getUpsertCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof upsertCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsPut
        >
      >,
      TError,
      { data: CategoryMarkupUpsert },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof upsertCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsPut
      >
    >,
    TError,
    { data: CategoryMarkupUpsert },
    TContext
  > => {
    const mutationKey = [
      'upsertCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof upsertCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsPut
        >
      >,
      { data: CategoryMarkupUpsert }
    > = (props) => {
      const { data } = props ?? {};

      return upsertCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsPut(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpsertCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof upsertCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsPut
      >
    >
  >;
export type UpsertCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsPutMutationBody =
  CategoryMarkupUpsert;
export type UpsertCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsPutMutationError =
  HTTPValidationError;

/**
 * @summary Upsert Category Markup
 */
export const useUpsertCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof upsertCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsPut
          >
        >,
        TError,
        { data: CategoryMarkupUpsert },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof upsertCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsPut
      >
    >,
    TError,
    { data: CategoryMarkupUpsert },
    TContext
  > => {
    const mutationOptions =
      getUpsertCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Remove a category's markup override (falls back to the tenant default).
 * @summary Delete Category Markup
 */
export const deleteCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsProductCategoryIdDelete =
  (productCategoryId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/procurement/settings/category-markups/${productCategoryId}`,
      method: 'DELETE'
    });
  };

export const getDeleteCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsProductCategoryIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsProductCategoryIdDelete
        >
      >,
      TError,
      { productCategoryId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsProductCategoryIdDelete
      >
    >,
    TError,
    { productCategoryId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsProductCategoryIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsProductCategoryIdDelete
        >
      >,
      { productCategoryId: string }
    > = (props) => {
      const { productCategoryId } = props ?? {};

      return deleteCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsProductCategoryIdDelete(
        productCategoryId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsProductCategoryIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsProductCategoryIdDelete
      >
    >
  >;

export type DeleteCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsProductCategoryIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Category Markup
 */
export const useDeleteCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsProductCategoryIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsProductCategoryIdDelete
          >
        >,
        TError,
        { productCategoryId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsProductCategoryIdDelete
      >
    >,
    TError,
    { productCategoryId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteCategoryMarkupApiV1ProcurementSettingsCategoryMarkupsProductCategoryIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
